import "swiper/css";

import React, { useEffect, useState } from "react";

import { DataContext } from "../contexts/runesContext";
import Img1 from "../assets/Chart.svg";
import Img2 from "../assets/challenges-completed.svg";
import Img3 from "../assets/challenges-rejected.svg";
import Img4 from "../assets/challenges-pending.svg";
import RegenerationCard from "./RegenerationCard";
import SliderSection from "./SliderSection";
import { SwiperSlide } from "swiper/react";
import useCollectors from "../hooks/useCollectors";
import { useContext } from "react";
import { useMoralis } from "react-moralis";
import { v4 } from "uuid";

// Import Swiper styles

const Regeneration = () => {
  const { contextData, setContextData } = useContext(DataContext);
  const { getRunes, getLeaderBoard } = useCollectors();
  const [dataSource, setDataSource] = useState();
  const [collected, setCollected] = useState(true);
  const { Moralis, account, isInitialized, isAuthenticated } = useMoralis();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (isInitialized && isAuthenticated) {
      const fetchStreak = async () => {
        const data = await getRunes();

        const { runes } = data.attributes;

        setContextData({ runes: runes });
        const dataLeader = await getLeaderBoard();
        setDataSource(dataLeader);
      };
      fetchStreak();
    } else {
      setCollected(true);
      setContextData({ runes: 0 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, isAuthenticated]);

  const challengesData = [
    {
      id: v4(),
      img: Img1,
      title: "OPIS",
      subtitle: contextData.runes,
      backgroundStyle: { backgroundColor: "#78D504" },
      imageSide: "right",
    },

    {
      id: v4(),
      title: "Completados",
      img: Img2,
      subtitle: "23",
      p1: { color: "#A3AED0", fontSize: "16px" },
      p2: { color: "#78D504" },
      imageSide: "right",
    },
    {
      id: v4(),
      title: "Pendientes",
      subtitle: "1",
      p1: { color: "#A3AED0", fontSize: "16px" },
      p2: { color: "#78D504" },
      img: Img4,
      imageSide: "left",
    },
    {
      id: v4(),
      title: "Rechazados",
      subtitle: "2",
      p1: { color: "#A3AED0", fontSize: "16px" },
      p2: { color: "#78D504" },
      img: Img3,
      imageSide: "left",
    },
  ];

  return (
    <SliderSection
      title={"Regeneración"}
      withArrows={true}
      sliderSectionStyle={{ height: "fit-content", marginBottom: "48px" }}
      spaceBetween={20}
    >
      {challengesData.map(
        ({ id, img, title, backgroundStyle, subtitle, imageSide, imageStyle, p1, p2 }) => (
          <SwiperSlide key={id} style={{ width: "fit-content" }}>
            <RegenerationCard
              key={id}
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              account={account}
              img={img}
              imageSide={imageSide}
              imageStyle={imageStyle}
              title={title}
              subtitle={subtitle}
              backgroundStyle={backgroundStyle}
              p1={p1}
              p2={p2}
            />
          </SwiperSlide>
        )
      )}
    </SliderSection>
  );
};

export default Regeneration;
